import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

/**
 * Route guard that redirects to companion creation if user has no companions.
 * Wraps protected routes (chat, companions list, etc.) to enforce
 * "create a companion first" flow.
 */
const RequireCompanion: React.FC = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [hasCompanion, setHasCompanion] = useState(false);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }

    const checkCompanions = async () => {
      try {
        const res = await axios.get('/companions');
        setHasCompanion(Array.isArray(res.data) && res.data.length > 0);
      } catch {
        setHasCompanion(false);
      } finally {
        setLoading(false);
      }
    };

    checkCompanions();
  }, [user]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-dark-bg">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500" />
      </div>
    );
  }

  if (!hasCompanion) {
    return <Navigate to="/companion/name" replace />;
  }

  return <Outlet />;
};

export default RequireCompanion;
